import styles from "../style";
import { Reveal } from "./reveal";


const Business = () =>  {
  return (
  <div className={`w-full justify-center items-center flex flex-col gap-6 py-20 px-10`}>
    <div className="flex flex-col md:flex-row md:gap-20 items-start md:items-center">
      <div className="flex flex-col gap-2 text-start md:items-end">
        <Reveal>
          <h2 className="kerning-normal xs:pt-6 xs:text-md text-white text-md text-start md:text-end font-semibold">
            Investment Focus
          </h2>
        </Reveal>
        <span className="xs:mb-6 border-b border-2 border-second w-[100px]"></span>        
        <Reveal>
          <div className="flex flex-col gap-2 text-start md:items-end">
            <p className={`kerning-normal xs:text-sm text-tertiary text-ss text-start md:text-end pt-2`}>
              We invest where innovation drives both returns and impact.
            </p>
            <p className={`kerning-normal xs:text-sm text-tertiary text-ss text-start md:text-end pb-4 max-w-[460px]`}>
              We bet on tech leapfrogging legacy systems and capturing explosive growth.
            </p>
              
          </div>      
        </Reveal>     
      </div>
      <div className=" flex flex-col gap-2 pb-10">
        <Reveal>          
          <div className={`py-10 flex flex-col`}>
            <p className={`kerning-normal xs:text-sm text-tertiary text-ss my-2 max-w-[500px]`}>
              <p className="kerning-normal font-semibold xs:text-mm text-sm text-second py-2">Demographic Power</p>A young, mobile-first population driving demand for digital services.
            </p>
            <p className={`kerning-normal xs:text-sm text-tertiary text-ss my-2 max-w-[500px]`}>
              <p className="kerning-normal font-semibold xs:text-mm text-sm text-second py-2">Economic Inflection</p>Rising urbanization, globalization, consumer spend, and deepening linkages between markets, are all creating massive new markets.
            </p>
            <p className={`kerning-normal xs:text-sm text-tertiary text-ss my-2 max-w-[500px]`}>
              <p className="kerning-normal font-semibold xs:text-mm text-sm text-second py-2">Regulatory Catalysts</p>Regional regulatory frameworks are enabling seamless cross border scale.
            </p>
          </div>
          
          
        </Reveal>
      </div>   
    </div>
    <div className={`justify-center pb-8`}>
      <Reveal >
        <div className={`flex flex-row gap-2 items-end`}>       
          <p className={`xs:text-mm text-tertiary text-sm  text-center justify-center flex flex-row gap-2`}>
            What Works & What Is
          </p> 
          <p className={`text-mm font-bold text-second`}>Next.</p>
        </div>
      </Reveal>
    </div>  
  </div>
)};

export default Business;